<template>
  <div>
    <Table
      @on-selection-change="onSelectionChange"
      ref="table"
      :columns="columns"
      :data="list"
      :loading="loading"
      stripe
      border
      @on-sort-change="onSortChange"
      @contextmenu.native="onContextMenu"
    >
      <template slot-scope="{ row, index }" slot="c1">
        <slot name="c1" :row="row" :index="index"></slot>
      </template>
      <template slot-scope="{ row, index }" slot="c2">
        <slot name="c2" :row="row" :index="index"></slot>
      </template>
      <template slot-scope="{ row, index }" slot="c3">
        <slot name="c3" :row="row" :index="index"></slot>
      </template>
      <template slot-scope="{ row, index }" slot="c4">
        <slot name="c4" :row="row" :index="index"></slot>
      </template>
      <template slot-scope="{ row, index }" slot="c5">
        <slot name="c5" :row="row" :index="index"></slot>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <slot name="action" :row="row" :index="index"></slot>
      </template>
    </Table>
    <div class="pager">
      <div class="f-left grid-footer-left">
        <slot name="footer-left"></slot>
      </div>
      <Page
        class="f-right"
        show-total
        @on-page-size-change="pageSizeChange"
        @on-change="changePage"
        :total="total"
        :current="page"
        show-elevator
        show-sizer
        transfer
        v-if="allowPage"
      />
    </div>
    <div
      class="ivu-select-dropdown"
      style="transform-origin: center bottom;"
      :style="{display:menu.isShow?'block':'none',left:menu.left+'px',top:menu.top+'px'}"
    >
      <ul class="ivu-dropdown-menu">
        <li class="ivu-dropdown-item" @click="exportExcel(list)">导出当前页</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Grid",
  props: {
    columns: {
      type: Array,
      required: true
    },
    dataUrl: {
      type: String,
      default: "",
      required: true
    },
    search: {
      type: Object
    },
    rowsFormatter: {
      type: Function
    },
    selectType: {
      type: String,
      default: "multi"
    },
    keyField: {
      type: String,
      default: "id"
    },
    selectedItems: {
      type: Array
    },
    keepSelected: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: "get"
    },
    allowPage: {
      type: Boolean,
      default: true
    },
    autoLoadData: {
      type: Boolean,
      default: true
    },
    rowSelectDisabled: {
      type: Function
    },
    enableExport: {
      type: Boolean,
      default: false
    },
    exportSheetName: {
      type: String,
      default: "sheet1"
    },
    exportFileName: {
      type: String,
      default: "export.xlsx"
    }
  },
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      currentRow: null,
      selectedRows: [],
      sortFiled: "",
      sortOrder: "",
      menu: {
        isShow: false,
        left: 0,
        top: 0
      },
      events: {
        handleEvent: () => {
          this.menu.isShow = false;
        }
      }
    };
  },
  async created() {
    this.initSelectedRows(this.selectedItems);

    if (this.selectType == "multi") {
      this.columns.unshift({
        type: "selection",
        width: 60,
        align: "center"
      });
    } else if (this.selectType == "single") {
      this.columns.unshift({
        title: "选择",
        width: 80,
        align: "center",
        render: (h, params) => {
          let self = this;
          let selected = false;
          let disabled = false;
          if (this.isSelected(params.row)) {
            selected = true;
          }
          if (this.rowSelectDisabled) {
            disabled = this.rowSelectDisabled(params.row);
          }
          return h("Radio", {
            props: {
              value: selected,
              disabled: disabled
            },
            on: {
              "on-change": () => {
                self.selectedRows = [params.row];
                self.onSelectionChange([params.row]);
              }
            }
          });
        }
      });
    }
    if (this.autoLoadData) {
      await this.getList(true, "created");
    }
    window.document.addEventListener("click", this.events);
  },
  watch: {
    selectedItems: {
      deep: true,
      handler: function() {
        this.initSelectedRows(this.selectedItems);
        this.setMultiSelected();
      }
    }
  },
  methods: {
    async getList(refresh) {
      if (!this.$store.state.token) {
        return;
      }
      if (this.loading || !this.dataUrl) {
        return;
      }
      if (refresh) {
        this.page = 1;
      }
      let obj = {
        page: this.page,
        limit: this.limit,
        ...this.search
      };
      if (this.sortFiled) {
        obj.sort_field = this.sortFiled;
      }
      if (this.sortOrder) {
        obj.sort = this.sortOrder;
      }
      this.loading = true;
      let data = await this.$http[this.method](this.dataUrl, obj, {
        onComplete: () => {
          this.loading = false;
        }
      });
      let list;
      if (this.allowPage) {
        this.total = data.total;
        list = data.list;
      } else {
        list = data;
      }
      if (this.rowsFormatter) {
        this.rowsFormatter(list);
      }
      this.list = list;
      this.setMultiSelected();
      if (list.length == 0 && !refresh && this.page > 1) {
        this.page--;
        this.getList(refresh);
      }
    },
    async pageSizeChange(d) {
      this.limit = d;
      await this.getList(true, "pageSizeChange");
    },
    async changePage(d) {
      this.page = d;
      await this.getList(false, "changePage");
    },
    onSelectionChange(items) {
      if (this.selectType == "multi" && this.keepSelected) {
        let selectedRows = this.selectedRows;
        let keyField = this.keyField;
        let data = this.$refs.table.$refs.tbody.objData;
        for (let key in data) {
          let row = data[key];
          let i = selectedRows.length - 1;
          for (; i >= 0; i--) {
            let item = selectedRows[i];
            if (item[keyField] == row[keyField]) {
              if (!row._isChecked) {
                selectedRows.splice(i, 1);
              }
              break;
            }
          }
          if (i < 0 && row._isChecked) {
            selectedRows.push({ ...row });
          }
        }
        items = selectedRows;
      }
      this.$emit("onSelectionChange", items);
    },
    async searchRefresh() {
      await this.getList(true, "searchRefresh");
    },
    async refresh() {
      await this.getList(false, "refresh");
    },
    getTotal() {
      return this.total;
    },
    isSelected(row) {
      let selectedRows = this.selectedRows;
      if (selectedRows.length == 0) {
        return false;
      }
      let keyField = this.keyField;
      for (let j = 0; j < selectedRows.length; j++) {
        let item = selectedRows[j];
        if (item[keyField] == row[keyField]) {
          return true;
        }
      }
      return false;
    },
    setMultiSelected() {
      if (this.selectType != "multi") {
        return;
      }
      this.$nextTick(() => {
        let data = this.$refs.table.$refs.tbody.objData;
        for (let key in data) {
          let row = data[key];
          row._isChecked = this.isSelected(row);
        }
      });
    },
    initSelectedRows(selectedItems) {
      if (!selectedItems) {
        return;
      }
      let selectedRows = [];
      selectedItems.forEach(item => {
        selectedRows.push({ ...item });
      });
      this.selectedRows = selectedRows;
    },
    recoverSelectedItems(selectedItems) {
      this.initSelectedRows(selectedItems);
      this.setMultiSelected();
    },
    async onSortChange(column) {
      this.sortFiled = column.key;
      this.sortOrder = column.order;
      await this.searchRefresh();
    },
    onContextMenu($event) {
      if (!this.enableExport) {
        return;
      }
      $event.stopPropagation();
      $event.preventDefault();
      this.menu.isShow = true;
      this.menu.left = $event.pageX;
      this.menu.top = $event.pageY;
    },
    exportExcel(list) {
      this.$pub.exportExcel(
        this.columns,
        list,
        this.exportSheetName,
        this.exportFileName
      );
    }
  },
  async activated() {
    if (this.autoLoadData) {
      await this.refresh(false);
    }
  },
  destroyed() {
    window.document.removeEventListener("click", this.events);
  }
};
</script>
<style lang="scss" scoped>
.pager {
  padding: 15px 0;
  overflow: hidden;
}
.ivu-select-dropdown {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
